// import { useCallback, useEffect, useState } from "react";

// export default function useTable(pageNumber = 1, limitCount = 10) {
//   const [page, setPage] = useState(pageNumber);
//   const [limit, setLimit] = useState(limitCount);
//   const [isResetPagination, setIsResetPagination] = useState(false);

//   const handleLimit = (val: number) => {
//     setLimit(Number(val));
//   };

//   const handlePagination = useCallback(
//     (paginationPage: number, paginationLimit: number) => {
//       setPage(paginationPage);
//       setLimit(paginationLimit);
//     },
//     []
//   );

//   const resetPagination = () => {
//     setIsResetPagination(true);
//   };

//   // When filtering, redirect table in first page
//   useEffect(() => {
//     if (isResetPagination) {
//       handlePagination(pageNumber, limitCount);
//       setIsResetPagination(false);
//     }
//   }, [handlePagination, isResetPagination, limitCount, pageNumber]);

//   return {
//     page,
//     limit,
//     handleLimit,
//     handlePagination,
//     resetPagination,
//   };
// }

import { useCallback, useEffect, useState } from "react";
import { skipData } from "../utils/utils";
import useDebounce from "./useDebounce";

interface UseTableType<T> {
  defaultPage?: number;
  defaultLimit?: number;
  hideSkipLimit?: boolean;
  defaultFilter?: T;
}

export default function useTable<T>(props?: UseTableType<T>) {
  const defaultPage = props?.defaultPage || 1,
    defaultLimit = props?.defaultLimit || 10;

  const [page, setPage] = useState(defaultPage);
  const [limit, setLimit] = useState(defaultLimit);
  const [isResetPagination, setIsResetPagination] = useState(false);
  const {
    keyword,
    handleInputChange: handleSearch,
    handleEnterValue,
  } = useDebounce();
  const [filter, setFilter] = useState<T>(props?.defaultFilter || ({} as T));

  const resetPagination = useCallback(() => {
    setIsResetPagination(true);
  }, []);

  const handleLimit = (val: number) => {
    setLimit(Number(val));
    handlePagination(defaultPage, Number(val));
  };

  const handlePagination = useCallback(
    (paginationPage: number, paginationLimit: number) => {
      setPage(paginationPage);
      setLimit(paginationLimit);
    },
    []
  );

  // When filtering, redirect table in first page
  useEffect(() => {
    if (isResetPagination) {
      handlePagination(defaultPage, defaultLimit);
      setIsResetPagination(false);
    }
  }, [handlePagination, isResetPagination, defaultLimit, defaultPage]);

  // handle filter
  const handleFilter = <K extends keyof T>(filterType: K, value: T[K]) => {
    setFilter((prev) =>
      prev
        ? ({
            ...prev,
            [filterType]: value,
          } as T)
        : ({
            [filterType]: value,
          } as T)
    );

    resetPagination();
  };

  // reset pagination when search
  useEffect(() => {
    if (keyword) resetPagination();
  }, [keyword, resetPagination]);

  const handleNext = () => {
    handlePagination(page + 1, limit);
  };

  const handlePrev = () => {
    if (page > 1) {
      handlePagination(page - 1, limit);
    }
  };

  return {
    page,
    limit,
    handleLimit,
    handlePagination,
    resetPagination,
    keyword,
    filter: {
      ...(!props?.hideSkipLimit ? { limit, skip: skipData(page, limit) } : {}),
      ...filter,
    } as T,
    handleSearch,
    handleNext,
    handlePrev,
    handleFilter,
    handleSearchEnter: handleEnterValue,
  };
}
